import React, { useState } from "react";
import { useTenantsApp } from "../../Context/TenantsApp/TenantsAppContext";
import { DELETE_TENANT, DISABLE_TENANT_INSTANCE, SET_INSTANCE_ID, SET_TENANT_ID, TOGGLE_DISABLE_APP_INSTANCE_DIALOG } from "./TenantsAppEvents";
import RemoveDialog from "../Shared/Remove/RemoveDialog";
import { disableInstanceOnRuntime } from "../Helpers/Runtime/runtime";
import { useMsal } from "@azure/msal-react";
import { getProject, updateProjectInstance } from "../../API/Project/project";

const DisableTenantAppInstance = () => {
    const msalContext = useMsal();
    const { state, dispatch } = useTenantsApp();
    const { selectedInstanceId, selectedTenantId, tenants } = state;
    const selectedTenant = tenants.find(tenant => tenant._id === selectedTenantId);
    const selectedInstance = selectedTenant ? selectedTenant.project?.tenantProject?.instances?.find(instance => instance._id === selectedInstanceId) : null;

    const [inProgress, setInProgress] = useState(false);

    if (!selectedTenant || !selectedInstanceId) {
        return null; // or handle the case where no tenant or instance is selected
    }

    const handleClose = () => {
        dispatch({ type: SET_TENANT_ID, payload: null });
        dispatch({ type: SET_INSTANCE_ID, payload: null });
        dispatch({ type: TOGGLE_DISABLE_APP_INSTANCE_DIALOG });
    }

    const handleDisableTenantApp = async () => {
        setInProgress(true);
        try {
            const project = await getProject(selectedTenant.project.tenantProjectId);
            if (!project) {
                dispatch({ type: DELETE_TENANT, payload: state.selectedTenantId });
                return;
            }

            let { instances } = project;

            const instanceToDisable = instances.find(instance => instance._id === selectedInstanceId);
            if (!instanceToDisable) {
                console.error("Instance not found in project");
                return;
            }

            const response = await disableInstanceOnRuntime(msalContext, project.organizationId, project.name, instanceToDisable._id);
            if (response.status === "Success") {
                await updateProjectInstance(project._id, instanceToDisable._id, { isActive: false });
            }
            dispatch({
                type: DISABLE_TENANT_INSTANCE,
                payload: {
                    tenantId: selectedTenantId,
                    instanceId: selectedInstanceId,
                }
            });
        } catch (error) {
            console.error("Error disabling tenant app instance:", error);
        } finally {
            setInProgress(false);
            handleClose();
        }
    }

    return (
        <RemoveDialog
            showLoader={inProgress}
            Title={"Disable Tenant App Instance"}
            toggleDeleteDialog={handleClose}
            message={`Are you sure you want to disable ${selectedInstance.instanceName.toLowerCase()} tenant app instance? This action cannot be undone.`}
            message2={"This will permanently disable the app and all associated data in the tenant instance. This action cannot be undone."}
            message3={"Do you want to proceed?"}
            onDelete={handleDisableTenantApp}
            onCancel={handleClose}
            deleteButtonText={"Disable"}
            cancelButtonText={"Cancel"}
        />
    )
}

export default DisableTenantAppInstance;